import { initTabs, tireSlotId, vehicleSlotId, wheelSlotId } from './tabs.js';

const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel', 'LiftHeight'];
const extraFitmentFields = [];
const tireFrontFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];
const tireRearFields = ['tire_width_rear', 'tire_aspect_rear', 'wheel_tire_diameter_rear'];
const tiresFields = [...tireFrontFields, ...tireRearFields];
const wheelsFields = ['wheel_tire_diameter', 'wheel_bolt_pattern'];
const vehicleSizeFields = ['wheel_tire_diameter'];
const ignoreFields = [...wheelsFields, ...tiresFields, ...vehicleSizeFields];

const searchPageUrl = '/shop/';
const brandSelectionPageUrl = '/brands/';
const categorySelectionPageUrl = '/categories/';
const wheelsCollectionUrl = '/wheels/';
const tiresCollectionUrl = '/tires/';

const isHomePage = window.location.pathname === '/';
const hasHomeVehicleWidgetSlot = !!window.document.querySelector('#cm_ymm');
const shouldUseHomeVehicleWidgetSlot = isHomePage || hasHomeVehicleWidgetSlot;
const isCategoryPage = window.document.body.classList.contains('tax-product_cat');
const isBrandPage = window.document.body.classList.contains('tax-product_brand');
const isSearchPage = window.location.pathname === searchPageUrl;
const isProductPage = window.document.body.classList.contains('single-product');
const isFitmentSearchPage =
  isSearchPage ||
  isCategoryPage ||
  isBrandPage ||
  isProductPage ||
  window.location.pathname === categorySelectionPageUrl ||
  window.location.pathname === brandSelectionPageUrl;

const getVariantId = () => new URLSearchParams(window.location.search).get('variation_id') || undefined;

function getLocalPreselection(pageType) {
  const preselection = [];

  if (pageType === 'category' && window.cm_category) {
    preselection.push({
      field: 'categories',
      term: window.cm_category,
      treeLevel: window.cm_category.length - 1,
    });
  }

  if (pageType === 'brand' && window.cm_brand) {
    preselection.push({
      field: 'brand',
      term: window.cm_brand,
    });
  }

  return preselection;
}

const updateCallback = () => {
  if (window._affirm_config && window.affirm?.ui) {
    // affirm.ui.ready()/refresh() can throw internally (e.g. "undefined is not an object")
    // on pages without promo elements, or when a store's own affirm snippet is misconfigured.
    try {
      window.affirm.ui.ready(function () {
        try {
          window.affirm.ui.refresh();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.debug(`affirm.ui.refresh(): ${e.message}`);
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.debug(`affirm.ui.ready(): ${e.message}`);
    }
  }

  if (window.katapult && window.katapult.estimatePrice) {
    window.katapult.estimatePrice();
  }
};

window.Convermax.getCategoryVehicleUrl = () => {
  return window.Convermax.getVehicleUrl('/categories/');
};

window.Convermax.updateOnVariantSelect = (e, variants) => {
  const selectedOptionId = e.target.value;
  const selectedProduct = getVariantOptionById(variants, selectedOptionId);

  const rootEl = e.target.closest('.cm-product-card');

  if (!rootEl || !selectedProduct) {
    console.error('Failed to update card with selected variant. Selected value: ', selectedOptionId);
    return;
  }

  rootEl
    .querySelectorAll('.affirm-as-low-as')
    .forEach((el) => el.classList.toggle('cm_hide', el.getAttribute('data-id') !== selectedOptionId));
  rootEl
    .querySelectorAll('.katapult-price-calculator')
    .forEach((el) => el.classList.toggle('cm_hide', el.getAttribute('data-id') !== selectedOptionId));
  rootEl
    .querySelectorAll('.cm-product-card__price')
    .forEach((el) => el.classList.toggle('cm_hide', el.getAttribute('data-id') !== selectedOptionId));
  rootEl
    .querySelectorAll('.cm-product-card__required-attributes-variant')
    .forEach((el) => el.classList.toggle('cm_hide', el.getAttribute('data-id') !== selectedOptionId));
  rootEl
    .querySelectorAll('.cm-product-card__specs-variant')
    .forEach((el) => el.classList.toggle('cm_hide', el.getAttribute('data-id') !== selectedOptionId));
  rootEl.querySelectorAll('.cm_add-to-cart-notice').forEach((el) => el.remove());
  rootEl.querySelectorAll('a[href]').forEach((el) => el.setAttribute('href', selectedProduct.url));

  const isOutOfStock =
    selectedProduct.stock_status === 'outofstock' ||
    selectedProduct.variant_rear?.stock_status === 'outofstock';
  updateQuantityForVariant(rootEl, selectedProduct);

  rootEl.querySelectorAll('.single_add_to_cart_button').forEach((button) => {
    button.value = selectedOptionId;
    button.disabled = isOutOfStock;

    const buttonText = button.querySelector('.cm_add-to-cart-text');
    if (buttonText) {
      buttonText.textContent = isOutOfStock
        ? button.dataset.outOfStockText || 'Sold Out'
        : button.dataset.defaultText || 'Add To Cart';
    }
  });
};

const InitFunc = () => {
  initTabs({
    baseFitmentFields,
    wheelsFields,
    tiresFields,
    shouldRenderSearchTabs: isHomePage || isFitmentSearchPage,
  });

  if (isProductPage) {
    const variationSelectElement = document.querySelector('#uvs-select');
    const queryString = window.location.search;

    // customer request: send the customer to the categories page
    // if they are on the product page when they click on the shop link in the breadcrumb
    const breadCrumbContainer = document.querySelector('.kadence-breadcrumb-container');
    if (breadCrumbContainer) {
      const shopUrl = [...breadCrumbContainer.children]
        .find((el) => el.textContent.trim() === 'Shop')
        ?.querySelector('a');

      if (shopUrl) {
        shopUrl.href = shopUrl.href.replace('shop', 'categories');
      }
    }

    if (variationSelectElement && queryString) {
      const urlParams = new URLSearchParams(queryString);
      const variantionId = urlParams.get('variation_id');
      if (variantionId) {
        variationSelectElement.value = variantionId;
        variationSelectElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    window.addEventListener('load', () => {
      if (variationSelectElement) {
        variationSelectElement.addEventListener('change', (e) => {
          setTimeout(() => {
            if (e.target.value) {
              window.Convermax.updateVerifyFitmentWidget(window.cm_product, e.target.value);
            }
          }, 300);
        });
      } else {
        jQuery('form.variations_form').on('found_variation', function (event, variationData) {
          if (variationData?.variation_id) {
            setTimeout(() => {
              window.Convermax.updateVerifyFitmentWidget(window.cm_product, variationData.variation_id);
            }, 300);
          }
        });
      }
    });
  }
};

async function updateStoreApiNonce() {
  const response = await fetch('/wp-json/wc/store/v1/cart', {
    credentials: 'same-origin',
  });

  const nonce = response.headers.get('Nonce');
  if (nonce) {
    localStorage.setItem('cm_store-api-nonce', nonce);
  }

  return nonce;
}

function getStoreApiNonce() {
  return localStorage.getItem('cm_store-api-nonce') || '';
}

function ajaxRequest(options, retryAttempt = 0) {
  const xhr = new XMLHttpRequest();

  xhr.open(options.type, options.url);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Nonce', getStoreApiNonce());

  xhr.onload = async function () {
    const parsedResponse = xhr.responseText ? JSON.parse(xhr.responseText) : {};
    if (xhr.status >= 200 && xhr.status < 300) {
      options.success(parsedResponse, xhr);
      return;
    }

    // we need manually refresh nonce when they are expired
    if (retryAttempt === 0 && parsedResponse.message?.toLowerCase()?.includes('nonce')) {
      try {
        localStorage.removeItem('cm_store-api-nonce');
        const updatedNonce = await updateStoreApiNonce();

        if (updatedNonce) {
          ajaxRequest(options, retryAttempt + 1);
          return;
        }
      } catch (error) {
        console.warn('Failed to refresh Store API nonce', error);
      }
    }

    if (options.error) {
      options.error(parsedResponse, xhr);
    }
  };

  xhr.onerror = function () {
    if (options.error) {
      options.error({}, xhr);
    }
  };

  xhr.send(JSON.stringify(options.data));
}

function ajaxAddToCart(options, retryAttempt = 0) {
  return ajaxRequest(options, retryAttempt);
}

function getQuantity(button) {
  return button.closest('.cm-product-card__actions')?.querySelector('.cm-qty__input')?.value || 1;
}

function normalizeAttributeValue(value) {
  return value?.replace(/ /g, '-').toLowerCase();
}

window.Convermax.getVariantOptionId = (variant) => {
  if (!variant) {
    return '';
  }

  const frontId = variant.product_id || variant.id;
  const rearId = variant.variant_rear?.product_id || variant.variant_rear?.id;

  return rearId && rearId !== frontId ? `${frontId}|${rearId}` : frontId;
};

window.Convermax.isStaggeredOption = (variant) => {
  const optionId = window.Convermax.getVariantOptionId(variant);
  return optionId.includes('|');
};

window.Convermax.getVariantOptionLabel = (variant) => {
  const frontLabel = variant.variant_label || variant.name || '';
  const rearLabel = variant.variant_rear?.variant_label || '';

  return rearLabel ? `F: ${frontLabel} | R: ${rearLabel}` : frontLabel;
};

function getVariantOptionById(variants, optionId) {
  return variants.find((variant) => window.Convermax.getVariantOptionId(variant) === optionId);
}

function parseVariantOptionId(optionId) {
  const [frontId, rearId] = (optionId || '').split('|');

  return {
    frontId,
    rearId: rearId && rearId !== frontId ? rearId : null,
  };
}

function getDefaultQuantityForVariant(variant, fitmentType) {
  if (!fitmentType?.includes('Wheel') && !fitmentType?.includes('Tire')) {
    return 1;
  }

  return window.Convermax.isStaggeredOption(variant) ? 2 : 4;
}

window.Convermax.getDefaultQuantityForVariant = getDefaultQuantityForVariant;

function updateQuantityForVariant(card, variant) {
  const quantityInput = card?.querySelector('.cm-qty__input');
  if (!quantityInput) {
    return;
  }

  const isStaggered = window.Convermax.isStaggeredOption(variant);
  const defaultQty = getDefaultQuantityForVariant(variant, card.dataset.fitmentType);
  const quantityControl = quantityInput.closest('.cm-qty');

  quantityControl?.classList.toggle('cm_hide', isStaggered);

  if (isStaggered || ['', '2', '4'].includes(quantityInput.value)) {
    quantityInput.value = defaultQty;
    quantityInput.setAttribute('value', defaultQty);
  }
}

function getSelectedRequiredAttributes(card, optionId, position = 'front') {
  const variantRequiredAttributesEl = card?.querySelector(
    `.cm-product-card__required-attributes-variant[data-id="${optionId}"][data-position="${position}"]`,
  );

  if (!variantRequiredAttributesEl) {
    return [];
  }

  return [...variantRequiredAttributesEl.querySelectorAll('.cm-product-card__required-attribute-control')]
    .map((control) => {
      const { attribute } = control.dataset;
      const value = normalizeAttributeValue(control.value);

      if (!attribute || !value || value === 'null') {
        return null;
      }

      return {
        attribute,
        value,
      };
    })
    .filter(Boolean);
}

function showHideAddToCartButtonSpinner(spinnerEl, textEl, show) {
  if (!spinnerEl && !textEl) {
    return;
  }

  if (show) {
    textEl.style.display = 'none';
  } else {
    textEl.style.display = 'block';
  }

  spinnerEl.classList.toggle('cm_hide');
}

function applyWcFragments(fragments) {
  if (!fragments || typeof fragments !== 'object') {
    return;
  }

  Object.keys(fragments).forEach((selector) => {
    const el = document.querySelector(selector);
    if (el) {
      el.outerHTML = fragments[selector];
    }
  });

  document.body.dispatchEvent(new CustomEvent('wc_fragments_loaded'));
}

function getAddToCartData(button, productId) {
  const card = button.closest('.cm-product-card');
  const variantSelect = card?.querySelector('.cm-product-card__variant-select');
  const quantity = getQuantity(button);

  if (variantSelect) {
    const optionId = variantSelect.value;
    const { frontId, rearId } = parseVariantOptionId(optionId);
    const selectedRequiredAttributes = getSelectedRequiredAttributes(card, optionId, 'front');
    const selectedRearRequiredAttributes = getSelectedRequiredAttributes(card, optionId, 'rear');

    const frontItem = {
      ['quantity']: quantity,
      ['id']: frontId,
    };

    if (selectedRequiredAttributes.length > 0) {
      frontItem.variation = selectedRequiredAttributes;
    }

    if (rearId) {
      const rearItem = {
        ['quantity']: quantity,
        ['id']: rearId,
      };

      if (selectedRearRequiredAttributes.length > 0) {
        rearItem.variation = selectedRearRequiredAttributes;
      }

      return [frontItem, rearItem];
    }

    return [frontItem];
  }

  return [
    {
      ['quantity']: quantity,
      ['id']: productId,
    },
  ];
}

function showAddToCartMessage(button, message, isError = false) {
  const card = button.closest('.cm-product-card');
  if (!card) {
    return;
  }

  card.querySelectorAll('.cm_add-to-cart-notice').forEach((el) => el.remove());

  const notice = document.createElement('div');

  notice.className = isError
    ? 'cm_add-to-cart-notice woocommerce-error'
    : 'cm_add-to-cart-notice woocommerce-message';

  notice.setAttribute('role', 'alert');

  if (message.includes('is not enough stock')) {
    // 'You cannot add that amount of &quot;PR181 - GLOSS BLACK&quot; to the cart because there is not enough stock (223 remaining).' => 223
    const stock = Number(message.split('is not enough stock')[1].match(/\d+/)?.[0] ?? 0);
    if (stock < 4) {
      notice.innerHTML = `Only ${stock} available. Lower quantity to add to cart.`;
    } else {
      notice.innerHTML = message;
    }
  } else {
    notice.innerHTML = message;
  }

  const info = card.querySelector('.cm-product-card__info');
  if (info) {
    info.insertBefore(notice, info.firstChild);
  } else {
    card.prepend(notice);
  }
}

function postAddToCartData(data) {
  return new Promise((resolve, reject) => {
    ajaxAddToCart({
      type: 'POST',
      url: '/wp-json/wc/store/v1/cart/add-item',
      data,
      success: (response, xhr) => {
        if (response?.code || response?.error) {
          reject({ response, xhr });
          return;
        }

        resolve({ response, xhr });
      },
      error: (response, xhr) => {
        reject({ response, xhr });
      },
      dataType: 'json',
    });
  });
}

async function addToCartRequest(button, productId) {
  if (!button) {
    return Promise.resolve(false);
  }

  button
    .closest('.cm-product-card')
    ?.querySelectorAll('.cm_add-to-cart-notice')
    .forEach((el) => el.remove());

  const buttonSpinner = button.querySelector('.cm_spinner');
  const buttonText = button.querySelector('.cm_add-to-cart-text');

  if (buttonSpinner && !buttonSpinner.classList.contains('cm_hide')) {
    return Promise.resolve(false);
  }

  showHideAddToCartButtonSpinner(buttonSpinner, buttonText, true);

  const dataItems = getAddToCartData(button, productId);
  const event = new CustomEvent('adding_to_cart', { detail: { button, data: dataItems } });
  document.body.dispatchEvent(event);

  try {
    let lastResponse = null;

    for (const data of dataItems) {
      const { response } = await postAddToCartData(data);
      lastResponse = response;
    }

    const addedEvent = new CustomEvent('added_to_cart', {
      // eslint-disable-next-line camelcase
      detail: { fragments: lastResponse?.fragments, cart_hash: lastResponse?.cart_hash, button },
    });

    showHideAddToCartButtonSpinner(buttonSpinner, buttonText, false);
    document.body.dispatchEvent(addedEvent);
    jQuery(document.body)?.trigger('wc_fragment_refresh');

    showAddToCartMessage(button, 'Added to Cart / <a href="/cart">View Cart</a>');
    return true;
  } catch ({ response }) {
    if (response?.fragments) {
      applyWcFragments(response.fragments);
    }

    showAddToCartMessage(button, response?.message || 'Failed to add to cart', true);
    showHideAddToCartButtonSpinner(buttonSpinner, buttonText, false);
    jQuery(document.body)?.trigger('wc_fragment_refresh');
    return false;
  }
}

window.Convermax.addToCart = (e, productId) => {
  e.preventDefault();
  return addToCartRequest(e.currentTarget || e.target?.closest('button'), productId);
};

window.Convermax.packageAddToCart = async (e, productId) => {
  e.preventDefault();

  const button = e.currentTarget || e.target?.closest('button');
  if (!button) {
    return true;
  }

  const addToCartData = getAddToCartData(button, productId);
  const frontWheelId = addToCartData[0]?.id;
  const rearWheelId = addToCartData[1]?.id;
  let wheelProductId = frontWheelId || productId;

  if (rearWheelId) {
    wheelProductId = `${productId}:${frontWheelId}:${productId}:${rearWheelId}`;
  } else if (productId && frontWheelId && productId !== frontWheelId) {
    wheelProductId = `${productId}:${frontWheelId}`;
  }

  const redirectPath = !wheelProductId
    ? tiresCollectionUrl
    : window.Convermax.getVehicleUrl(`${tiresCollectionUrl}?WheelProductID/${wheelProductId}`);
  const addedToCart = await addToCartRequest(button, productId);

  if (addedToCart) {
    window.location.assign(redirectPath);
  }

  return addedToCart;
};

const scrollToResults = () => {
  if (!isFitmentSearchPage || isHomePage) {
    return;
  }

  const deadline = Date.now() + 2000;
  const tryScroll = () => {
    const searchResult = document.querySelector('.cm_SearchPage');
    if (searchResult) {
      searchResult.scrollIntoView({ behavior: 'instant', block: 'start' });
    } else if (Date.now() < deadline) {
      setTimeout(tryScroll, 50);
    }
  };
  tryScroll();
};

const vehicleSelectionShouldNotBeLoaded = () => {
  return (
    window.location.search &&
    [...tiresFields, ...wheelsFields].some((f) => window.location.search.includes(f))
  );
};

const onVerifyFitmentResponseReceived = (response) => {
  const variationSelectElement = document.querySelector('#uvs-select');
  const product = response.Items?.[0];
  const productVariants = product?._variants;

  if (variationSelectElement && productVariants?.length > 0) {
    const fitVariantsIds = productVariants.map((v) => v.id);

    variationSelectElement.querySelectorAll('option').forEach((el) => {
      const isOptionFitsVehicle = fitVariantsIds.includes(el.value) || el.selected;
      el.classList.toggle('cm_hide', !isOptionFitsVehicle);
    });
  }
};

function facetResponseHandler(response) {
  if (window.document.querySelector(' body.tax-product_cat #main')) {
    response.Facets.forEach((f) => {
      if (f.FieldName === 'categories') {
        f.Values = f.Values.filter((v) => !v.Selected);
      }
    });
  }

  return response;
}

export default {
  platform: 'woocommerce',
  defaultView: 'grid',
  searchPageUrl,
  sortFields: ['relevance', 'price', 'price:desc', 'name', 'name:desc'],
  getLocalPreselection,
  facetResponseHandler,
  InitFunc,
  page: {
    getPageType(defaults) {
      return window.cm_category ? 'category' : window.cm_brand ? 'brand' : defaults.getter();
    },
  },
  product: {
    getVariantId,
  },
  SearchRequestDefaults: {
    pageSize: 36,
    sort: 'relevance',
    extra: {
      ...(window.cm_category ? { pageType: 'categories' } : window.cm_brand ? { pageType: 'brand' } : {}),
    },
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'categories' },
      { pathname: brandSelectionPageUrl, field: 'brand' },
    ],
    doNotLoadSelectedVehicle: vehicleSelectionShouldNotBeLoaded(),
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
    onVerifyFitmentResponseReceived,
    categorySelectionPageRedirect: true,
    onVehicleSelected: scrollToResults,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#main',
      template: 'SearchPage',
      visibleIf: () => isSearchPage,
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      location: {
        insertBefore: 'body.tax-product_cat #main',
      },
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'categories',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: 'body.tax-product_brand #main, body.tax-product_cat #main',
      template: 'SearchPage',
    },
    // Keeps search.response.extra populated on category selection pages for AutoSync visualization.
    {
      name: 'CategorySelectionSearchPage',
      type: 'SearchPage',
      location: { lastChildOf: 'body', class: 'cm_hide' },
      template: 'EmptySearchPage',
      visibleIf: () =>
        window.location.pathname === categorySelectionPageUrl ||
        window.location.pathname === brandSelectionPageUrl,
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchResult',
      updateCallback,
    },
    {
      name: 'SearchBoxDialogButtonDesktop',
      type: 'SearchBoxDialogButton',
      location: {
        selector: '[data-section="kadence_customizer_header_search"]',
        class: 'cm_search-box-root__desktop-container',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        lastChildOf: '#mobile-header .site-header-section-left',
        class: 'cm_search-box-root__mobile-container',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: vehicleSizeFields,
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm_brand-list',
      isVehicleWidgetDisabled: true,
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_category-list',
      isVehicleWidgetDisabled: true,
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: { selector: `#${vehicleSlotId}`, class: 'cm_vehicle-widget__tabs' },
      template: 'fitmentSearch/headerVehicleWidget',
      columnBreakpoint: 800,
      isAlwaysActive: shouldUseHomeVehicleWidgetSlot,
      useAutoSyncVisualizer: true,
      isVehicleSelectionIsolated: true,
      doNotRedirectOnVehicleSelect: isFitmentSearchPage,
      useNativeDropdown: false,
      autoOpenDropdowns: 'next',
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: { selector: `#${wheelSlotId}`, class: 'cm_vehicle-widget__tabs' },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
      redirectUrl: wheelsCollectionUrl,
      shouldBeIsolated: () => shouldUseHomeVehicleWidgetSlot,
      onSubmit: scrollToResults,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: { selector: `#${tireSlotId}`, class: 'cm_vehicle-widget__tabs' },
      template: 'TirePanelTab',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      selectFields: tiresFields,
      redirectUrl: tiresCollectionUrl,
      shouldBeIsolated: () => shouldUseHomeVehicleWidgetSlot,
      onSubmit: scrollToResults,
    },
    {
      name: 'Garage',
      location: {
        insertAfter: '[data-section="kadence_customizer_header_search"]',
        class: 'cm_garage-container__desktop',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: {
        insertBefore:
          '#mobile-header .site-header-section-right [data-section="kadence_customizer_mobile_cart"]',
        class: 'cm_garage-container__mobile',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.product-template-default .kwt-add-to-cart-wrap',
        class: 'cm_vehicle-widget__verify-fitment-container',
      },
      template: 'fitmentSearch/collapsibleVerifyFitment',
      initCollapsed: true,
    },
    {
      name: 'AutoSyncVisualizationDialog',
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
